import type { FC } from 'react';
import type { AirportWithActive, TranslatedProperty } from '@/types/domain/core';
import { Flex, Indicator, Typography } from '@ui';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './AirportsListItem.module.css';

type Props = {
    airport: AirportWithActive;
    selected?: boolean;
    onSelect: VoidFunction;
    airportId: number;
};

export const AirportsListItem: FC<Props> = ({ airport, selected, onSelect, airportId }) => {
    const { i18n } = useTranslation();

    const lang = i18n.language as keyof TranslatedProperty;

    return (
        <Flex
            gap={16}
            className={clsx(styles.container, selected && styles.selected)}
            onClick={onSelect}
            data-airport-id={airportId}
        >
            <Flex align="center" justify="center" className={styles.icao}>
                <Typography.Paragraph color="textSecondary">{airport.icao}</Typography.Paragraph>
            </Flex>
            <Flex vertical justify="center" flex="1 0">
                <Typography.Paragraph level={2} color="textSecondary">
                    {airport.name?.[lang] || airport.city[lang]}
                </Typography.Paragraph>
                {airport.name && (
                    <Typography.Description color="textSecondary">
                        {airport.city[lang]}
                    </Typography.Description>
                )}
            </Flex>
            {airport.active && (
                <Flex align="center">
                    <Indicator />
                </Flex>
            )}
        </Flex>
    );
};
